import { render, staticRenderFns } from "./facilitys.vue?vue&type=template&id=0961cbe3"
import script from "./facilitys.vue?vue&type=script&lang=js"
export * from "./facilitys.vue?vue&type=script&lang=js"
import style0 from "./facilitys.vue?vue&type=style&index=0&id=0961cbe3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports